<div class="dialog-updated">
  <h2 mat-dialog-title>
    {{ 'QUOTATIONS.UPDATED.TITLE' | translate }}
  </h2>

  <mat-dialog-content>
    <p>
      {{ 'QUOTATIONS.UPDATED.TEXT' | translate }}
    </p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button
      data-cy="update-outdated-quotation"
      class="field-background"
      mat-raised-button
      mat-dialog-close
      cdkFocusInitial
    >
      <span>{{ 'QUOTATIONS.UPDATED.BUTTON' | translate }}</span>
    </button>
  </mat-dialog-actions>
</div>
